<template>
  <div class="sincerityPayMent">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="wrapper">
      <div v-if="payResult == 'success'" class="main">
        <div class="payment-img">
          <img src="@/assets/image/AccountDeal/sellSincerityPayMentSucc.png" alt="">
        </div>
        <div class="payment-status">支付成功</div>
        <div class="payment-tip">服务订单已支付成功，商品已成功发布</div>
        <div class="payment-btn">
          <router-link to="/personalCenter/seller/sincerity" class="btn btn-left">
            查看服务订单
          </router-link>
          <router-link to="/accountSell" class="btn btn-right">
            继续发布商品
          </router-link>
        </div>
      </div>
      <div v-else class="main error">
        <div class="payment-img">
          <img src="@/assets/image/AccountDeal/sellSincerityPayMentError.png" alt="">
        </div>
        <!-- <div class="payment-status">支付成功</div> -->
        <div class="payment-tip">支付失败，若已支付请联系客服查询</div>
        <div class="payment-btn">
          <a href="javascript: void(0);" @click="productAdd" class="btn btn-left">
            仅发布商品<br>不购买诚心卖服务
          </a>
          <a href="javascript: void(0);" @click="goOnPay" class="btn btn-right">
            继续支付发布商品
          </a>
        </div>
      </div>
      <!-- <div class="downlandAPP">
        <img src="@/assets/image/AccountDeal/downloadApp.gif" alt="">
      </div> -->
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import {
  apiPaypayserve,
  apiServeQuery
} from "@/request/API";
export default {
  name: 'Sinceritypayment',
  components: {
    breadcrumb,
  },
  data() {
    return {
      breadcrumbList: [
        {name: '发布商品'}
      ],
      payResult: 'success',
      orderid: this.$route.query.orderid,
      uniqueno: this.$route.query.uniqueno,
      id: this.$route.query.id,
      game_id: this.$route.query.gameid,
    }
  },
  created() {
    this.payQuery()
  },
  mounted() {},
  methods: {
    payQuery() {
      apiServeQuery({
        id: this.orderid
      }).then(res => {
        if (res.data.code === 200) {
          this.payResult = 'success'
        }else{
          this.payResult = 'error'
        }
      }).catch(err => {
        this.payResult = 'error'
      })
    },
    /**
     * @description: 继续支付发布商品
     * @return {*}
     */
    goOnPay() {
      apiPaypayserve({
        id: this.orderid,
        return_url:`${process.env.VUE_APP_WEBSITE}/sinceritypayment?orderid=${this.orderid}&id=${this.id}&gameid=${this.game_id}&uniqueno=${this.uniqueno}`
      }).then(res=>{
        const div = document.createElement("divform");
        div.innerHTML = res.data.from_data
        document.body.appendChild(div);
        document.forms[0].acceptCharset = "GBK"; // 保持与支付宝默认编码格式一致，如果不一致将会出现：调试错误，请回到请求来源地，重新发起请求，错误代码 invalid-signature 错误原因: 验签出错，建议检查签名字符串或签名私钥与应用公钥是否匹配
        document.forms[0].submit();
        div.remove();
      }).catch(() => {
        this.$message.error('请稍后重试!')
      })
    },
    /**
     * @description: 只发布商品不购买诚心卖
     * @return {*}
     */
    productAdd() {
      this.$router.push({
        path: '/accountSell',
        query: {
          sincerity: 1,
          gameid: this.game_id,
          id: this.id,
          uniqueno: this.uniqueno
        },
      })
    },
  },
}
</script>

<style scoped lang="less">
.sincerityPayMent {
  width: 1200px;
  max-width: 100%;

  .wrapper{
    position: relative;

    .main{
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      flex: 1;
      min-height: 360px;
      padding: 52px 0;
      box-sizing: border-box;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      .payment-img{
        width: 144px;
        height: 118px;
        margin-bottom: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--success-soft, #ECFDF5);
        border-radius: 4px;

        img{
          width: 120px;
          height: 94.46px;
          display: block;
        }
      }

      .payment-status{
        margin-bottom: 8px;
        font-size: 22px;
        line-height: 31px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: var(--text-main, #111827);
      }

      .payment-tip{
        min-height: 22px;
        margin-top: 0;
        text-align: center;
        width: auto;
        max-width: 320px;
        font-size: 14px;
        line-height: 22px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-secondary, #5A5F6B);
      }

      .payment-btn{
        margin-top: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 12px;

        .btn{
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 184px;
          height: 40px;
          padding: 0 16px;
          box-sizing: border-box;
          font-size: 14px;
          line-height: 20px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: var(--text-secondary, #5A5F6B);
          border-radius: 3px;
          text-align: center;
          transition: color .2s ease, background .2s ease, border-color .2s ease, box-shadow .2s ease;
        }

        .btn-left{
          border: 1.5px solid var(--bg-dark, #1A1D24);
          background: var(--bg-card, #FFFFFF);
          color: var(--text-main, #1A1D24);

          &:hover {
            background: var(--bg-tag, #F0EDE8);
          }
        }

        .btn-right{
          border: 1px solid var(--primary, #FF5A1F);
          background: var(--primary, #FF5A1F);
          color: #FFFFFF;
          box-shadow: 0 8px 18px rgba(255, 90, 31, 0.22);

          &:hover {
            border-color: var(--primary-hover, #E84A12);
            background: var(--primary-hover, #E84A12);
          }
        }
      }
    }

    .error{
      .payment-img {
        background: var(--danger-soft, #FEF2F2);
      }

      .payment-tip{
        width: auto;
      }

      .payment-btn{
        .btn-left{
          font-size: 14px;
          line-height: 17px;
          white-space: normal;
        }
      }
    }

    .downlandAPP{
      flex: 0 0 224px;
      min-height: 356px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-sizing: border-box;

      img{
        display: block;
        width: 183px;
        height: 262px;
      }
    }
  }
}

</style>
